import React, {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useContext,
    useState,
} from 'react';

type PortalProviderProps = {
    children?: ReactNode;
};

type Context = {
    setContent: Dispatch<SetStateAction<ReactNode>>;
};

const PortalContext = createContext<Context>({
    setContent: () => {},
});

export default function PortalProvider(props: PortalProviderProps) {
    const { children } = props;
    const [content, setContent] = useState<ReactNode | undefined>();

    return (
        <PortalContext.Provider value={{ setContent }}>
            {content && <div>{content}</div>}
            {children}
        </PortalContext.Provider>
    );
}

export function usePortal() {
    return useContext(PortalContext);
}
